import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Icon, Row, Col, Typography } from 'antd';
import LMNotificationSettingsForm from './LMNotificationSettingsForm';
const { Text, Title } = Typography;

function LMNotificationSettings(props) {
	return (
		<React.Fragment>
			<Title level={4}>{props.title}</Title>
			<LMNotificationSettingsForm {...props} />
		</React.Fragment>
	);
}

export default withRouter(LMNotificationSettings);
